import { EBrandTitle } from 'affiny-core/types/env.types';

const injectFavicon = (rel: string, type: string, url: string) => {
  const faviconEl = document.createElement('link');

  faviconEl.setAttribute('rel', rel);
  faviconEl.setAttribute('type', type);
  faviconEl.setAttribute('href', url);

  return faviconEl;
};

export const setMetaInformations = (
  locale: string,
  brandCode: string
): void => {
  // set HTML root lang attribute
  document.documentElement.lang = locale;
  // set document title
  document.title = EBrandTitle[brandCode];
  // set favicon dynamically
  const headTitle = document.querySelector('head');

  headTitle?.appendChild(
    injectFavicon(
      'shortcut icon',
      'image/x-icon',
      `${process.env.PUBLIC_URL}/favicon/favicon-${brandCode}.ico`
    )
  );
  headTitle?.appendChild(
    injectFavicon(
      'icon',
      'image/png',
      `${process.env.PUBLIC_URL}/favicon/favicon-${brandCode}.png`
    )
  );
};
